import * as React from 'react';

export type IconSize = 'lg' | 'md' | 'sm' | 'xs';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: IconSize;
}

export const SIZE_MAP: Record<IconSize, number> = {
  lg: 24,
  md: 20,
  sm: 16,
  xs: 12,
};
